import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "nav-shell" }
const _hoisted_2 = { class: "hero-inner" }
const _hoisted_3 = { class: "hero-actions" }
const _hoisted_4 = {
  href: "tel:+496111234567",
  class: "btn primary"
}
const _hoisted_5 = { class: "hero-meta" }
const _hoisted_6 = {
  id: "speisekarte",
  class: "menu-section section-pad"
}
const _hoisted_7 = { class: "tabs" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "dish-grid" }
const _hoisted_10 = { class: "menu-note" }
const _hoisted_11 = { class: "experience" }
const _hoisted_12 = { href: "tel:+496111234567" }
const _hoisted_13 = { class: "quote" }
const _hoisted_14 = {
  id: "besuch",
  class: "visit section-pad"
}
const _hoisted_15 = { class: "visit-grid" }
const _hoisted_16 = {
  id: "reservieren",
  class: "reservation phone-reservation"
}
const _hoisted_17 = {
  class: "phone-card",
  href: "tel:+496111234567"
}

import { ref } from 'vue';
import { ArrowRight, Clock3, MapPin, Menu, Phone, Star, UtensilsCrossed, X } from 'lucide-vue-next';
import '@/assets/styles/home.css';
import heroImage from '@/assets/images/jadedrache-hero.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const mobileOpen = ref(false);
const category = ref('Vorspeisen');
const menu = {
  Vorspeisen: [
    ['Edamame', 'Meersalz · gerösteter Sesam', '6'],
    ['Gemüse Gyoza', 'Chinakohl · Ingwer · Soja', '9'],
    ['Lachs Tataki', 'Ponzu · Sesam · Frühlingslauch', '16'],
    ['Jade Bao', 'Schweinebauch · Gurke · Hoisin', '12'],
    ['Crispy Tofu', 'Szechuan-Mayo · Kräuter', '10'],
    ['Tuna Tatar', 'Avocado · Yuzu · Reiscracker', '17'],
  ],
  Hauptgerichte: [
    ['Jade Ramen', 'Miso-Brühe · Pak Choi · Ei · Chiliöl', '18'],
    ['Knusprige Ente', 'Pflaume · Wokgemüse · Jasminreis', '24'],
    ['Black Pepper Beef', 'Rinderfilet · Paprika · schwarzer Pfeffer', '27'],
    ['Miso Lachs', 'Wilder Brokkoli · Dashi · Sesamreis', '26'],
    ['Korean Fried Chicken', 'Gochujang · Frühlingslauch · Pickles', '21'],
    ['Jade Curry', 'Kokos · Zitronengras · Gemüse · Reis', '20'],
    ['Peking Ente', 'Mandarin-Pfannkuchen · Gurke · Hoisin', '29'],
    ['Teriyaki Hähnchen', 'Sesam · Brokkoli · Jasminreis', '21'],
    ['Szechuan Rind', 'Chili · Knoblauch · Paprika · Reis', '25'],
    ['Char Siu Pork', 'Honigglasur · Pak Choi · Duftreis', '23'],
    ['Tonkotsu Ramen', 'Schweinebauch · Ei · Nori · Bambus', '21'],
    ['Shoyu Ramen', 'Hähnchen · Soja-Brühe · Mais · Ei', '19'],
    ['Yaki Udon', 'Rindfleisch · Udon · Wokgemüse', '22'],
    ['Pad Thai', 'Garnelen · Reisnudeln · Erdnuss · Limette', '22'],
    ['Red Thai Duck', 'Rote Currysauce · Ananas · Thai-Basilikum', '25'],
    ['Garnelen Tempura', 'Dashi · Rettich · Sesamreis', '24'],
    ['Wasabi Tuna', 'Thunfischsteak · Wasabi-Kartoffel · Ponzu', '29'],
    ['Seafood Laksa', 'Garnelen · Muscheln · Kokos · Reisnudeln', '26'],
    ['Bulgogi Bowl', 'Mariniertes Rind · Kimchi · Ei · Reis', '23'],
    ['Five Spice Chicken', 'Fünf-Gewürze · Wokgemüse · Reis', '22'],
  ],
  Vegetarisch: [
    ['Mapo Tofu', 'Szechuanpfeffer · Pilze · Reis', '17'],
    ['Miso Aubergine', 'Sesam · Frühlingslauch · Reis', '18'],
    ['Grünes Thai Curry', 'Kokos · Zuckerschoten · Thai-Basilikum', '19'],
    ['Dan Dan Noodles', 'Sesam · Pak Choi · Chili · Erdnuss', '17'],
    ['Wokgemüse', 'Ingwer · Soja · Cashew · Reis', '16'],
  ],
  Sushi: [
    ['Jadedrache Roll', 'Lachs · Avocado · Gurke · Tobiko', '18'],
    ['Spicy Tuna Roll', 'Thunfisch · Chili · Frühlingslauch', '17'],
    ['Crunchy Veggie Roll', 'Avocado · Spargel · Tempura', '15'],
    ['Sashimi Selection', 'Lachs · Thunfisch · Hamachi, 12 Stück', '29'],
    ['Nigiri Set', 'Auswahl des Küchenchefs, 8 Stück', '24'],
  ],
  Desserts: [
    ['Matcha Tiramisu', 'Mascarpone · Kakao · Matcha', '9'],
    ['Mango Mochi', 'Kokos · Limette', '8'],
    ['Sesam Eis', 'Schwarzer Sesam · Karamell', '8'],
    ['Yuzu Cheesecake', 'Weißer Sesam · Yuzu-Gel', '10'],
  ],
  Getränke: [
    ['Jasmin Eistee', 'Hausgemacht · Limette · Minze', '6'],
    ['Lychee Spritz', 'Lychee · Yuzu · Soda, alkoholfrei', '8'],
    ['Jade Highball', 'Japanese Whisky · Ingwer · Soda', '12'],
    ['Sake Selection', 'Junmai Ginjo, 0,1 l', '9'],
    ['Grüner Tee', 'Sencha oder Jasmin, Kännchen', '5'],
  ]
};
const close = () => mobileOpen.value = false;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("a", {
        class: "brand",
        href: "#start",
        onClick: close
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("span", { class: "brand-mark" }, "J", -1),
        _createElementVNode("span", null, [
          _createTextVNode("JADEDRACHE"),
          _createElementVNode("small", null, "ASIAN KITCHEN")
        ], -1)
      ]))]),
      _createElementVNode("nav", {
        class: _normalizeClass({ open: mobileOpen.value }),
        "aria-label": "Hauptnavigation"
      }, [
        _createElementVNode("a", {
          href: "#story",
          onClick: close
        }, "Unsere Küche"),
        _createElementVNode("a", {
          href: "#speisekarte",
          onClick: close
        }, "Speisekarte"),
        _createElementVNode("a", {
          href: "#besuch",
          onClick: close
        }, "Besuch"),
        _createElementVNode("a", {
          href: "tel:+496111234567",
          class: "nav-cta",
          onClick: close
        }, [
          _createVNode(_unref(Phone)),
          _cache[2] || (_cache[2] = _createTextVNode(" 0611 123 45 67", -1))
        ])
      ], 2),
      _createElementVNode("button", {
        class: "menu-toggle",
        "aria-label": "Menü öffnen",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (mobileOpen.value = !mobileOpen.value))
      }, [
        (mobileOpen.value)
          ? (_openBlock(), _createBlock(_unref(X), { key: 0 }))
          : (_openBlock(), _createBlock(_unref(Menu), { key: 1 }))
      ])
    ]),
    _createElementVNode("section", {
      id: "start",
      class: "hero",
      style: _normalizeStyle({ backgroundImage: `linear-gradient(90deg, rgba(2,13,29,.98) 0%, rgba(2,13,29,.82) 42%, rgba(2,13,29,.15) 75%), url(${_unref(heroImage)})` })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "eyebrow" }, [
          _createElementVNode("span"),
          _createTextVNode(" Moderne asiatische Küche · Wiesbaden")
        ], -1)),
        _cache[8] || (_cache[8] = _createElementVNode("h1", null, [
          _createTextVNode("Asien im Herzen."),
          _createElementVNode("br"),
          _createElementVNode("em", null, "Blau in der Seele.")
        ], -1)),
        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "hero-copy" }, "Feine Aromen, handverlesene Zutaten und ehrliches Handwerk – serviert in einer Atmosphäre zwischen Shanghai und Wiesbaden.", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", _hoisted_4, [
            _createVNode(_unref(Phone)),
            _cache[3] || (_cache[3] = _createTextVNode(" 0611 123 45 67", -1))
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("a", {
            href: "#speisekarte",
            class: "btn ghost"
          }, "Speisekarte entdecken", -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, [
            _createVNode(_unref(Star)),
            _cache[5] || (_cache[5] = _createTextVNode(" 4,8 bei unseren Gästen", -1))
          ]),
          _createElementVNode("span", null, [
            _createVNode(_unref(Clock3)),
            _cache[6] || (_cache[6] = _createTextVNode(" Di–So ab 17 Uhr", -1))
          ])
        ])
      ])
    ], 4),
    _cache[34] || (_cache[34] = _createStaticVNode("<section id=\"story\" class=\"story section-pad\"><div class=\"story-label\">01 <span></span> UNSERE PHILOSOPHIE</div><div><h2>Tradition trifft<br><em>neue Perspektive.</em></h2><p>Unsere Küche verbindet die aromatische Vielfalt Ostasiens mit einer modernen, leichten Handschrift. Hausgemachte Brühen, lokale Produkte und Gewürze, die ihre eigene Geschichte erzählen.</p><p>Wir kochen nicht einfach Gerichte. Wir schaffen einen Abend, an den man sich erinnert.</p><div class=\"signature\">蒼龍 <span>KÜCHENCHEF LIN</span></div></div><div class=\"story-card\"><span>SEIT 2018</span><strong>6</strong><p>Jahre voller Geschmack, Begegnungen und gemeinsamer Abende.</p></div></section>", 1)),
    _createElementVNode("section", _hoisted_6, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "section-heading" }, [
        _createElementVNode("p", { class: "eyebrow dark" }, [
          _createElementVNode("span"),
          _createTextVNode(" UNSERE SPEISEKARTE")
        ]),
        _createElementVNode("h2", null, [
          _createTextVNode("Einmal quer durch"),
          _createElementVNode("br"),
          _createElementVNode("em", null, "unsere Küche.")
        ]),
        _createElementVNode("p", { class: "menu-intro" }, "Zum Teilen, Entdecken oder ganz für sich allein – alle Gerichte werden frisch für Sie zubereitet.")
      ], -1)),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menu, (_, name) => {
          return _createElementVNode("button", {
            key: name,
            class: _normalizeClass({active: category.value === name}),
            onClick: ($event: any) => (category.value = name)
          }, _toDisplayString(name), 11, _hoisted_8)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu[category.value as keyof typeof menu], (dish, index) => {
          return (_openBlock(), _createElementBlock("article", {
            key: dish[0],
            class: "dish"
          }, [
            _createElementVNode("span", null, "0" + _toDisplayString(index + 1), 1),
            _createElementVNode("div", null, [
              _createElementVNode("h3", null, _toDisplayString(dish[0]), 1),
              _createElementVNode("p", null, _toDisplayString(dish[1]), 1)
            ]),
            _createElementVNode("strong", null, _toDisplayString(dish[2]) + " €", 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("p", _hoisted_10, [
        _createVNode(_unref(UtensilsCrossed)),
        _cache[10] || (_cache[10] = _createTextVNode(" Alle Gerichte können auf Wunsch in ihrer Schärfe angepasst werden.", -1))
      ])
    ]),
    _createElementVNode("section", _hoisted_11, [
      _createElementVNode("div", null, [
        _cache[13] || (_cache[13] = _createElementVNode("p", { class: "eyebrow" }, [
          _createElementVNode("span"),
          _createTextVNode(" DER ABEND GEHÖRT IHNEN")
        ], -1)),
        _cache[14] || (_cache[14] = _createElementVNode("h2", null, [
          _createTextVNode("Mehr als ein Essen."),
          _createElementVNode("br"),
          _createElementVNode("em", null, "Ein Erlebnis.")
        ], -1)),
        _cache[15] || (_cache[15] = _createElementVNode("p", null, "Gedämpftes Licht, tiefe Blautöne und der Duft frisch gerösteter Gewürze. Ob erstes Date, Familienabend oder besonderer Anlass – bei uns darf die Zeit kurz stillstehen.", -1)),
        _createElementVNode("a", _hoisted_12, [
          _cache[12] || (_cache[12] = _createTextVNode("Jetzt telefonisch reservieren ", -1)),
          _createVNode(_unref(Phone))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_unref(Star)),
        _cache[16] || (_cache[16] = _createElementVNode("p", null, "„Ein Ort, an dem jedes Detail stimmt – vom ersten Tee bis zum letzten Bissen.“", -1)),
        _cache[17] || (_cache[17] = _createElementVNode("span", null, "— MARA K. · WIESBADEN", -1))
      ])
    ]),
    _createElementVNode("section", _hoisted_14, [
      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "section-heading" }, [
        _createElementVNode("p", { class: "eyebrow dark" }, [
          _createElementVNode("span"),
          _createTextVNode(" IHR BESUCH")
        ]),
        _createElementVNode("h2", null, [
          _createTextVNode("Wir freuen uns"),
          _createElementVNode("br"),
          _createElementVNode("em", null, "auf Sie.")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", null, [
          _createVNode(_unref(MapPin)),
          _cache[18] || (_cache[18] = _createElementVNode("h3", null, "Adresse", -1)),
          _cache[19] || (_cache[19] = _createElementVNode("p", null, [
            _createTextVNode("Taunusstraße 24"),
            _createElementVNode("br"),
            _createTextVNode("65183 Wiesbaden")
          ], -1)),
          _cache[20] || (_cache[20] = _createElementVNode("a", {
            href: "https://maps.google.com",
            target: "_blank",
            rel: "noopener"
          }, "Route anzeigen →", -1))
        ]),
        _createElementVNode("div", null, [
          _createVNode(_unref(Clock3)),
          _cache[21] || (_cache[21] = _createElementVNode("h3", null, "Öffnungszeiten", -1)),
          _cache[22] || (_cache[22] = _createElementVNode("p", null, [
            _createTextVNode("Di–Sa: 17:00–23:00"),
            _createElementVNode("br"),
            _createTextVNode("So: 17:00–22:00"),
            _createElementVNode("br"),
            _createTextVNode("Montag Ruhetag")
          ], -1))
        ]),
        _createElementVNode("div", null, [
          _createVNode(_unref(Phone)),
          _cache[23] || (_cache[23] = _createElementVNode("h3", null, "Kontakt", -1)),
          _cache[24] || (_cache[24] = _createElementVNode("p", null, [
            _createTextVNode("0611 123 45 67"),
            _createElementVNode("br"),
            _createTextVNode("hallo@jadedrache.de")
          ], -1)),
          _cache[25] || (_cache[25] = _createElementVNode("a", { href: "tel:+496111234567" }, "Direkt anrufen →", -1))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_16, [
      _cache[30] || (_cache[30] = _createElementVNode("div", null, [
        _createElementVNode("p", { class: "eyebrow" }, [
          _createElementVNode("span"),
          _createTextVNode(" TISCHRESERVIERUNG")
        ]),
        _createElementVNode("h2", null, "Ein Anruf genügt."),
        _createElementVNode("p", null, "Rufen Sie uns während der Öffnungszeiten an. Wir bestätigen Ihren Wunschtermin direkt persönlich.")
      ], -1)),
      _createElementVNode("a", _hoisted_17, [
        _createElementVNode("span", null, [
          _createVNode(_unref(Phone))
        ]),
        _cache[28] || (_cache[28] = _createElementVNode("small", null, "RESERVIERUNG UNTER", -1)),
        _cache[29] || (_cache[29] = _createElementVNode("strong", null, "0611 123 45 67", -1)),
        _createElementVNode("em", null, [
          _cache[27] || (_cache[27] = _createTextVNode("Jetzt anrufen ", -1)),
          _createVNode(_unref(ArrowRight))
        ])
      ])
    ]),
    _createElementVNode("footer", null, [
      _cache[33] || (_cache[33] = _createElementVNode("div", { class: "brand" }, [
        _createElementVNode("span", { class: "brand-mark" }, "J"),
        _createElementVNode("span", null, [
          _createTextVNode("JADEDRACHE"),
          _createElementVNode("small", null, "ASIAN KITCHEN")
        ])
      ], -1)),
      _createElementVNode("p", null, "© " + _toDisplayString(new Date().getFullYear()) + " Jadedrache · Demo-Website", 1),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, { to: "/impressum" }, {
          default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
            _createTextVNode("Impressum", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/datenschutz" }, {
          default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
            _createTextVNode("Datenschutz", -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})